import gql from 'graphql-tag';

export const projectFragments = gql`
  fragment projectFragments on Project {
    id
    code
    name
  }
`;

export const ALL_PROJECTS = gql`
  query currentUnitProjects {
    currentUnit {
      id
      projects {
        ...projectFragments
      }
    }
  },
  ${projectFragments}
`;


